@charset "UTF-8";

/* src/app/agent-builder/agent-builder-messages-log-detail/agent-builder-messages-log-detail.component.scss */
:host {
  position: relative;
  display: flex;
  overflow: auto;
  width: 100%;
  height: 100%;
}
nz-spin {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}
::ng-deep nz-spin .ant-spin {
  display: flex !important;
  justify-content: center !important;
}
.rounds-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.round-container {
  margin-bottom: 40px;
  padding: 20px;
  background: #fafafa;
  border-radius: 10px;
  border: 1px solid #eee;
}
.round-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.conv-timeline {
  padding-left: 10px;
}
.bubble {
  border-radius: 10px;
  padding: 14px 18px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  width: 100%;
  position: relative;
}
.bubble-user {
  background: #f0f5ff;
  border-left: 4px solid #2f54eb;
}
.bubble-instrucoes {
  background: #e6f7ff;
  border-left: 4px solid #1890ff;
}
.bubble-feedback {
  background: #fff1f0;
  border-left: 4px solid #ff4d4f;
}
.bubble-doc-user {
  background: #f9f0ff;
  border-left: 4px solid #9254de;
}
.bubble-doc-rag {
  background: #fffbe6;
  border-left: 4px solid #faad14;
}
.bubble-assistant {
  background: #f6ffed;
  border-left: 4px solid #52c41a;
}
.bubble-tool {
  background: #fff7e6;
  border-left: 4px solid #fa8c16;
}
.header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.meta {
  margin-left: 10px;
}
.role {
  font-weight: 600;
}
.timestamp {
  font-size: 12px;
  color: #999;
}
.tool-collapse {
  margin-top: 12px;
}
pre {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
}
.token-info {
  margin-top: 8px;
  padding: 8px 10px;
  background: #f7f7f7;
  border-radius: 6px;
  font-size: 12px;
  color: #555;
  border-left: 3px solid #ffb86d;
}
.token-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
}
.token-row:last-child {
  margin-bottom: 0;
}
.token-row.total .label {
  font-weight: 600;
}
.token-row.id {
  margin-top: 6px;
  font-size: 11px;
  color: #777;
}
.label {
  font-weight: 500;
}
.value {
  font-family: monospace;
}
.token-icon {
  position: absolute;
  top: 6px;
  right: 8px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s ease;
  z-index: 10;
}
.token-icon:hover {
  color: #555;
}
.token-popover {
  font-size: 12px;
  color: #444;
  min-width: 180px;
}
.token-popover .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.token-popover .row.total .label {
  font-weight: 600;
}
.token-popover .row.id {
  margin-top: 6px;
  font-size: 11px;
  color: #777;
}
.token-popover .label {
  font-weight: 500;
}
.token-popover .value {
  font-family: monospace;
}
.log-detail-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.rounds-wrapper {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=agent-builder-messages-log-detail.component.css.map */
